import { useCallback } from "react";
import { useGlobalModuleTabs } from "src/App/useGlobalModuleTabs.ts";
import { isInIframe } from "@exonn/utils";
import { FormAction } from "src/components/Form/Form.types.ts";

/**
 * Opens a record the way every list in the application opens one.
 *
 * Two paths, and both are needed: embedded in exonn.online the app has no tab
 * bar of its own, so the host is asked to open the record; standalone it opens
 * an internal tab. Skipping the first would make double-click do nothing at all
 * for anyone using the embedded ERP.
 */
export const useOpenRecord = () => {
  const globalModuleTabs = useGlobalModuleTabs();

  return useCallback(
    (resource: string, id: string) => {
      if (isInIframe()) {
        window.parent.postMessage(
          {
            eventName: "OPEN_ERP2_ENTITY",
            payload: { resource, type: "edit", id },
          },
          "https://exonn.online",
        );

        return;
      }

      globalModuleTabs.api.openTab({
        resource,
        type: "form",
        action: FormAction.Edit,
        id,
      });
    },
    [globalModuleTabs.api],
  );
};
